import React, { useState, createContext, useContext, useEffect } from "react";

export const PermissionsContext = createContext();

export const ContextPermissionsProvider = ({
  permissions: curPermissions,
  children,
}) => {
  const [permissions, setPermissions] = useState(curPermissions);

  useEffect(() => {
    setPermissions(curPermissions);
  }, [curPermissions]);

  return (
    <PermissionsContext.Provider value={[permissions, setPermissions]}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissionsContext = () => {
  const [permissions, setPermissions] = useContext(PermissionsContext);
  return { permissions, setPermissions };
};
